import { Inject, LOCALE_ID, Pipe, PipeTransform } from "@angular/core";
import { DatePipe } from "@angular/common";

/**
 * La fecha de un renglón de bitácora.
 *
 * Los movimientos que hace la gente desde la pantalla traen su hora y hay que
 * verla: dos cambios del mismo día no se distinguen de otra forma. En cambio
 * los renglones sembrados por script salen de una columna DATE y caen en
 * medianoche exacta, así que su "00:00" no es una hora, es relleno; en esos se
 * imprime solo el día.
 *
 * La hora se calcula con el mismo DatePipe que después la imprime, y con el
 * idioma que tenga la aplicación, para que la decisión y lo que se ve no
 * puedan discrepar por zona horaria.
 */
@Pipe({ name: "fechaBitacora", standalone: true })
export class FechaBitacoraPipe implements PipeTransform {
  private readonly fecha: DatePipe;

  constructor(@Inject(LOCALE_ID) idioma: string) {
    this.fecha = new DatePipe(idioma);
  }

  transform(valor?: Date | string | number | null): string {
    if (!valor) {
      return "—";
    }
    const dia = this.fecha.transform(valor, "dd/MM/yyyy");
    if (!dia) {
      return "—";
    }
    const hora = this.fecha.transform(valor, "HH:mm");
    return !hora || hora === "00:00" ? dia : dia + " " + hora;
  }
}
